import React, {Component} from 'react';
//import {Total} from './components/total/Total'; //along with: export function Total(){...}
import Total from './components/total/Total'; //along with: export default Total;//at EOF
import History from './components/history/History';
import Operation from './components/operation/Operation';
import Counter from './components/Counter';

/* <React.Fragment> </React.Fragment> === <></>  */
/*
    <>
       <header>
         <h1>Wallet</h1>
       </header>

       <main>Main Block</main>
    </>
*/

//function App() {
class App extends Component {

  /* //Option-2://  
    state = {};*/
  // State-keeping, option-1
  constructor(props){
    super(props);
    this.state = {
      //Any-state-property
      //transactions: [],
      //            \/ Load data: ||[]
      transactions: JSON.parse(localStorage.getItem('calc-money')) || [],
      description: '',
      amount: '',

      total: 0,
      expenses: 0,
      incomes: 0,
    };

    this.addAmount = this.addAmount.bind(this);
  }

  /*
  UNSAFE_componentWillMount(){
    this.setTotalBalance();
  }*/
  
  componentDidMount(){
    this.setTotalBalance();
    //-console.log('componentDidMount: setTotalBalance()');
  }
  /* Read more on this: 
      React: componentWillMount to be deprecated!
      https://blog.northcoders.com/react-componentwillmount-to-be-deprecated
        From: ggl: react replace UNSAFE_componentWillMount 
   */

  /*  
  componentDidUpdate(){
    console.log('componentDidUpdate');
    //this.saveToStorageLocal();
  }*/

  //declaring function-in-a-property
  //setTotalBalance; // Public class fields, see desc at: 
     // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Classes/Public_class_fields

  //addTransaction(add){
  addTransaction = add => {
    const transactions = [...this.state.transactions];
    const new_transaction = {
      id: `cmr${(+new Date()).toString(16)}`, //`cmr${(+new Date.toString(16)}`
      description: this.state.description,
      amount: this.state.amount,
      add: add, //add
    }
    //this.state.transactions.push( new_transaction); //так не можем, тк React не узнает
    transactions.push( new_transaction);
    // Prev. way: const transactions = [...this.state.transactions, new_transaction];

    //this.setState({transactions}, ()=>console.log('this.state: ', this.state) ); //norm+log
    this.setState({
      transactions,
      description:'',
      amount:''
    //},  this.setTotalComponentValues);
    //},  () => this.setTotalComponentValues());
    },  () => {
      this.setTotalBalance();
      this.saveToStorageLocal();
    });
  };

  addDescription = e => {
    this.setState({description: e.target.value});
  }

  addAmount(e){ //e = event
    //this.state.amount = e.target.value; //так не можем, тк React не узнает
    this.setState({amount: e.target.value});
    //*this.setState({amount: e.target.value}, ()=>{console.log('this.state= ', this.state)});
    //console.log('this.state= ', this.state);
  }

  //Total, functinonality:
  calcTotal = (t) => {
    //reduce() docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
    /*let total = this.state.transactions
           .map(tr => (tr.add?+1:-1)* tr.amount)
           .reduce((sum, signed_tr) => sum + signed_tr, 0); */
    let total = this.state.transactions
          .reduce((sum, tr) => sum + (tr.add?+1:-1) * Number(tr.amount), 0);
    return total;
  };

  calcIncomes = (t) => {
    let incomes = t
          .reduce((sum, tr) => sum + (tr.add? Number(tr.amount) : 0), 0);
    return incomes;
  };

  calcExpenses = (t) => {
    let expenses = t
          .reduce((sum, tr) => sum + (!tr.add? Number(tr.amount) : 0), 0);
    return expenses;
  };
  
  /** prev.name: setTotalComponentValues */
  setTotalBalance = () => { 
    let t = this.state.transactions;
    let incomes = this.calcIncomes(t);
    let expenses = this.calcExpenses(t);
    //let total = this.calcTotal(t);
    let total = incomes - expenses;
    this.setState({total, incomes, expenses});
    //console.log('setTotalBalance() called (calls setState)');
  };

  //localStorage!
  saveToStorageLocal(){ // "add<into-the>Storage()"
    //localStorage.setItem('calc-money', this.state.transactions);
    localStorage.setItem('calc-money', JSON.stringify(this.state.transactions));
    console.log('saveToStorageLocal called');
  }
  
  delTransaction = id => {
    let transactions = this.state.transactions.filter(tr => tr.id !== id);
    //this.setState({transactions}, this.setTotalBalance); //2nd-arg is cb-function
    this.setState({transactions}, () => {
      this.setTotalBalance();
      this.saveToStorageLocal();
    });
  };
  
  doBackupOrRestore = (backupOrRestore) => {
    if (backupOrRestore) { //backup
      localStorage.setItem('calc-money-Backup', JSON.stringify(this.state.transactions));
      console.log("[Toast] Backup saved to 'calc-money-Backup'");
    }
    else { //restore
      let transactions = JSON.parse(localStorage.getItem('calc-money-Backup')) || [];
      this.setState({transactions},  () => {
        this.setTotalBalance();
        this.saveToStorageLocal();
      });
      console.log("[Toast] backup Restored from 'calc-money-Backup'");
    }
    /*backup of backup: localStorage.setItem('calc-money-Backup', 
       [{"id":"cmr1740db5a527","description":"Вася отдал","amount":"1000","add":true},{"id":"cmr1740db5dbef","description":"Петя отдал","amount":"500","add":true},{"id":"cmr1740db60507","description":"Маша вернула","amount":"500","add":true},{"id":"cmr1740db63437","description":"На кота портатил","amount":"1200","add":false}]
     ); */
  }


  render() {
    return (
      <>
        <header>
          <h1>Кошелек</h1>
          <h2>Калькулятор расходов</h2>
        </header>

        <main>
          <div className="container">
            <Total 
              total={this.state.total}
              expenses={this.state.expenses}
              incomes={this.state.incomes}
              />

            <History 
              transactions={this.state.transactions}
              delTransaction={this.delTransaction}
              />

            <Operation 
              addTransaction={this.addTransaction}
              addDescription={this.addDescription}
              addAmount={this.addAmount}
              description={this.state.description}
              amount={this.state.amount}
              doBackupOrRestore={this.doBackupOrRestore}
              />
          </div>
        </main>
        <Counter />
      </>
    );
  }
}

export default App;
